module.exports = __webpack_public_path__ + "media/images/logo_aceim-d37b55ac.png";